import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IProject } from 'projects/types';
import { Color } from 'theme/enums';

import { UpsertProject } from './UpsertProject';

interface IProps {
  onAddProjectSuccess?: (project: IProject) => void;
}

export const AddProjectButton = ({ onAddProjectSuccess }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        color={Color.SUCCESS}
        text={t('buttonLabelAddProject')}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <UpsertProject
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onAddProjectSuccess}
      />
    </>
  );
};
